// extracted by mini-css-extract-plugin
module.exports = {"review":"review_review__B_xxk","top":"review_top__3oCdG","stars":"review_stars__plJdB","text":"review_text__qnVpE","useBorder":"review_useBorder__HT_s_"};